// @ts-nocheck
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const shadows: Styleguide["shadows"] = {
    small: `0 0 ${pxToRem(1)} 0 rgba(48,49,51,0.05), 0 ${pxToRem(4)} ${pxToRem(8)} 0 rgba(48,49,51,0.1)}`,
    main: ` 0 0 ${pxToRem(1)} 0 rgba(48,49,51,0.05), 0 ${pxToRem(16)} ${pxToRem(24)} 0  rgba(48,49,51,0.1)}`,
    alt: `0 ${pxToRem(-1)} ${pxToRem(10)} rgb(172,171,171,0.3)}`,
};

export default shadows;
